/// <reference path='../../../typings/browser.d.ts' />

namespace Application.Controllers {
  'use strict';
  import Utils = Common.Utils;
  import ConnectionRoom = Models.ConnectionRoom;
  import IBlock = Application.Models.IBlock;
  import INetworkNode = Application.Models.NetworkNode;

  export interface IMonitorProbeModalScope extends ng.IScope {
    blocksInfo: IBlock[] | any; // source and sink block
    srtUrl: string;
    modalClose: () => void;
    getMonitorDevices: () => void;
    loading: boolean;
    monitorDevices: Models.NetworkNode[];
    monitorBlocks: IBlock[] | any;
    setMonitor: (block: IBlock) => void;
    stopMonitor: (block: IBlock) => void;
  }

  /**
   * MonitorProbeController class
   */
  export class MonitorProbeController {
    public static templateURL: string = 'decorators/modals/monitor-probe-modal.html';
    public static ID: string = '#id-monitor-probe-modal';
    public static $name: string = 'monitorProbeModalController';
    public connectionRooms: ConnectionRoom[];
    public static $inject: string[] = [
      '$scope',
      'close',
      '$timeout',
      'blocksInfo',
      'srtUrl',
      'networkNodeService',
      'blockService',
      'streamPipeService',
      'probeService',
    ];

    private scope: IMonitorProbeModalScope;
    private close: (parameters: ngModal.ICloseParameters) => void;

    /**
     * Constructor
     */
    constructor(
      $scope: IMonitorProbeModalScope,
      close: (parameters: ngModal.ICloseParameters) => void,
      $timeout: ng.ITimeoutService,
      blocksInfo: IBlock[],
      srtUrl: string,
      private networkNodeService: Services.NetworkNodeService,
      private blockService: Services.BlockService,
      private streamPipeService: Services.StreamPipeService,
      private probeService: Services.ProbeService,
    ) {
      this.scope = $scope;
      this.scope.loading = false;
      this.scope.blocksInfo = blocksInfo;
      this.scope.srtUrl = srtUrl;

      $timeout(() => {
        window.altair_admin_common_init();
      }, 500);

      this.close = close;

      this.scope.modalClose = (): void => {
        this.close(undefined);
      };

      this.scope.setMonitor = (block: IBlock): void => {
        this.setMonitor(block);
      };

      this.scope.stopMonitor = (block: IBlock): void => {
        this.stopMonitor(block);
      };

      this.getMonitorDevices();

    }
    async getMonitorDevices(): Promise<void>{
      this.scope.monitorDevices = await this.networkNodeService.getMonitorNodes();
      this.getMonitorBlocks(); 
    }

    async getMonitorBlocks(){
      this.scope.loading = true;
      this.scope.monitorBlocks = await this.blockService.getMonitorBlocks(this.scope.monitorDevices);
      this.scope.loading = false;
    }

    setMonitor(block: IBlock){
      if(block.blockType.naturalKey === 'Intinor_DR'){
        this.scope.loading = true;
        const srtParams: any = this.extractSrtParamsFromUrl(this.scope.srtUrl)
        if(srtParams === null){ console.log("Please wait for srt url to be built"); alert("Please wait for srt url to be built"); return; }
        srtParams.blockIndex = block.config.index;
        srtParams.startProbe = true;
        srtParams.streamId = block.name;
        srtParams.device = block.config.serial;
        srtParams.sinkBlockName = this.scope.blocksInfo[1].name;

        this.probeService.sendIntinorEvent(srtParams).then( (res: any) => {
          this.scope.loading = false;
        });

        this.setIntinorMonitorInfoInSinkBlock(block, srtParams);
      }else{
        this.setUrlInDevice(block);
      }
      this.scope.loading = true;
      this.setMonitorFlagInBlock(block);
    }

    /**
     * 
     * @param srtUrl 
     * @returns obj.ip, obj.port, obj.passphrase
     */
    extractSrtParamsFromUrl(url: string) {
      try {
          const urlObj = new URL(url);
          const ip = urlObj.hostname;
          const port = urlObj.port;
          const passphrase = Utils.getUrlParam(url, "passphrase");
          
          if (!ip || !port || !passphrase) {
              throw new Error("Missing required parameters");
          }
  
          return { ip, port, passphrase };
      } catch (error) {
          console.log("Invalid SRT URL");
          return null;
      }
  }
    
    // update url field in MVP device
    setUrlInDevice(block: IBlock){
      console.log("srtUrl: ", this.scope.srtUrl);
      this.streamPipeService.setMvpMonitorUrl(block.id, this.scope.srtUrl);
    }

    /**
     * Identify block as a monitor block
     */
    setMonitorFlagInBlock(block: IBlock){
      // srt block id
      block.config.monitoring = this.scope.blocksInfo[1].blockConnection.origBlock.id;
      // sink block name
      block.config.monitoringName = this.scope.blocksInfo[1].name;
      //sink block id
      block.config.monitoringSinkId = this.scope.blocksInfo[1].blockConnection.destBlockId;
      this.blockService.updateBlock(block).then( (res: any)=> {
        this.scope.loading = false;
      });
    }

    /**
     * Save in Sink block (Virtual) the information about the intinor block probing the srt in the sink block connection
     */
    async setIntinorMonitorInfoInSinkBlock(block: IBlock, srtInfo: any){
      const sinkBlockWithMonitor = await this.blockService.findById(this.scope.blocksInfo[1].blockConnection.destBlock.id);
      sinkBlockWithMonitor.config.monitoringInfo = 
      { 
        "deviceSerialNumber": srtInfo.device,
        "index": srtInfo.blockIndex,
      }
      this.blockService.updateBlock(sinkBlockWithMonitor).then
      ( (res: any) => {
        console.log("Sink block updated with monitor info: ", res);
      });
    }

    /**
     * Identify block as a monitor block
     */
    async unsetIntinorMonitorInfoInSinkBlock(block: IBlock){
      // remove monitor info from sink block (could be from any intinor block, so we search by name)
      // const sinkBlockWithMonitor = await this.blockService.findByName(block.config.monitoringName);
      const sinkBlockWithMonitor = await this.blockService.findById(block.config.monitoringSinkId);
       delete sinkBlockWithMonitor.config.monitoringInfo;
      this.blockService.updateBlock(sinkBlockWithMonitor).then
      ( (res: any) => {
        console.log("Sink block updated with monitor info: ", res);
      });
    }

    stopMonitor(block: IBlock){
      if(block.blockType.naturalKey === 'Intinor_DR'){
        this.scope.loading = true;
        const srtParams: any = this.extractSrtParamsFromUrl(this.scope.srtUrl)
        if(srtParams === null){ console.log("Please wait for srt url to be built"); alert("Please wait for srt url to be built"); return; }
        srtParams.blockIndex = block.config.index;
        srtParams.startProbe = false;
        srtParams.streamId = block.name;
        srtParams.device = block.config.serial;
        srtParams.sinkBlockName = block.config.monitoringName;
        
        this.probeService.sendIntinorEvent(srtParams).then( (res: any) => {
          this.scope.loading = false;
        });
        this.unsetIntinorMonitorInfoInSinkBlock(block);
      }else{
        this.unsetUrlInDevice(block);
      }
      this.scope.loading = true;
      this.unsetMonitorFlagInBlock(block);
    }

    unsetMonitorFlagInBlock(block: IBlock){
      delete block.config.monitoring;
      delete block.config.monitoringName;
      delete block.config.monitoringSinkId;
      this.blockService.updateBlock(block).then( (res: any)=> {
        this.scope.loading = false;
      });
    }

    unsetUrlInDevice(block: IBlock){
      this.streamPipeService.unsetMvpMonitorUrl(block.id);
    }

  }
}
